import type { CityConfig } from "../city-template/types";

export const petersburgVaConfig: CityConfig = {
  city: "Petersburg",
  state: "Virginia",
  stateAbbr: "VA",
  slug: "petersburg-va",
  route: "/petersburg-va",
  title: "Emergency Passport Petersburg, VA — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Petersburg, VA — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving the Tri-Cities, Fort Lee, and the Southside Virginia region. Get your passport fast!",
  h1: "Emergency & Expedited Passport Services in Petersburg, VA",
  heroSubtitle: "Passport expired before your trip? Traveling from the Tri-Cities, Fort Lee, or Southside Virginia? We help Petersburg travelers get expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Petersburg%20Virginia%20historic%20downtown%20with%20the%20Appomattox%20River%2C%20the%20historic%20Petersburg%20Courthouse%20and%20Bollingbrook%20Street%2C%20the%20historic%20warehouse%20district%20along%20the%20river%2C%20Victorian-era%20architecture%20and%20brick-lined%20streets%2C%20the%20Fort%20Lee%20military%20installation%20visible%20in%20the%20surrounding%20countryside%2C%20warm%20afternoon%20light%20with%20the%20rolling%20Southside%20Virginia%20hills%2C%20professional%20photography%20showcasing%20Petersburg%20historic%20river%20city%20with%20Civil%20War%20heritage%20and%20modern%20Tri-Cities%20identity%2C%20no%20people%20visible%2C%20scenic%20urban%20landscape&width=1800&height=700&seq=petersburg-va-hero-001&orientation=landscape",
  heroImageAlt: "Petersburg Virginia historic downtown with the Appomattox River, the Petersburg Courthouse, and Fort Lee visible in the countryside",
  geoPosition: "37.2279;-77.4019",
  geoPlacename: "Petersburg, Virginia",
  regionalAgency: {
    name: "Washington Passport Agency",
    address: "600 19th Street NW, Washington, DC 20006",
    distance: "Located in downtown Washington, DC — approximately 130 miles north of Petersburg via I-95",
  },
  nearbyCitiesZips: [
    { name: "Petersburg", zips: "23803, 23804, 23805, 23806" },
    { name: "Colonial Heights", zips: "23834" },
    { name: "Hopewell", zips: "23860" },
    { name: "Fort Lee", zips: "23801" },
    { name: "Dinwiddie", zips: "23841" },
    { name: "Prince George County", zips: "23805, 23842, 23860, 23875, 23885" },
    { name: "Chesterfield", zips: "23832, 23834, 23836, 23838" },
    { name: "Chester", zips: "23831, 23832, 23836" },
    { name: "Richmond", zips: "23218, 23219, 23220, 23221, 23222, 23223, 23224, 23225, 23226, 23227, 23228, 23229, 23230, 23231, 23233, 23234, 23235, 23236, 23237, 23238, 23242" },
    { name: "Midlothian", zips: "23112, 23113, 23114" },
    { name: "Glen Allen", zips: "23058, 23059, 23060" },
    { name: "Henrico", zips: "23228, 23229, 23231, 23233, 23238, 23242, 23255, 23294" },
    { name: "Emporia", zips: "23847" },
    { name: "South Hill", zips: "23970" },
    { name: "Franklin", zips: "23851" },
    { name: "Dinwiddie County", zips: "23803, 23805, 23830, 23833, 23841, 23872, 23875, 23882, 23885, 23889" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent travel departures from the Tri-Cities and Southside Virginia" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Tri-Cities Hub", desc: "Serving Petersburg, Colonial Heights, Hopewell, Fort Lee, and Chesterfield" },
  ],
  internalLinks: [
    { name: "Virginia state passport services", route: "/states/virginia" },
    { name: "Richmond VA passport services", route: "/richmond-va" },
    { name: "Lynchburg VA passport services", route: "/lynchburg-va" },
    { name: "Fredericksburg VA passport services", route: "/fredericksburg-va" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Petersburg remotely via secure courier. We do not have a walk-in office in Petersburg — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Petersburg and Tri-Cities travelers.",
  fpcOfficeAddress: "7272 Wisconsin Ave, Bethesda, Maryland 20814",
  fpcOfficeDistance: "Serving all of Petersburg and the Tri-Cities region including Colonial Heights, Hopewell, Fort Lee, Chesterfield, and Dinwiddie County",
  serviceAreaIntro: "From the historic downtown of Petersburg to the military base at Fort Lee, from the quiet neighborhoods of Colonial Heights to the industrial corridors of Hopewell, from the rural communities of Dinwiddie County to the suburban edges of Chesterfield, from the shores of the Appomattox River to the growing communities of Prince George County — Fast Passport Center serves every corner of Petersburg and the Southside Virginia region. We regularly help travelers from Fort Lee, Colonial Heights, and Chester get their passports fast.",
  nearbyCitiesIntro: "We serve all Petersburg neighborhoods and the Tri-Cities region including Colonial Heights, Hopewell, Fort Lee, Chesterfield, Chester, and Dinwiddie County.",
  howItWorksIntro: "Most Petersburg travelers complete everything online and ship documents overnight. No need to drive to the Washington regional agency or wait in long government lines.",
  mistakesIntro: "Petersburg travelers often face the temptation to drive to the Washington regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Petersburg and Tri-Cities travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Petersburg? Here are the most common ones we hear from Tri-Cities and Southside Virginia travelers.",
  statePageRoute: "/states/virginia",
  statePageName: "Virginia",
  dmvWebsite: "https://www.dmv.virginia.gov",
  dmvLabel: "Virginia DMV — Official Website",
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { icon: "ri-user-smile-line", label: "Birth Certificate", desc: "Request certified birth certificates from Virginia Department of Health Vital Records. Online, mail, or in-person options available for Petersburg and Tri-Cities area residents.", url: "https://www.vdh.virginia.gov/vital-records/" },
    { icon: "ri-file-list-2-line", label: "Death Certificate", desc: "Obtain certified death certificates through Virginia Department of Health Vital Records. Required for estate, insurance, and legal matters.", url: "https://www.vdh.virginia.gov/vital-records/" },
    { icon: "ri-hearts-line", label: "Marriage Certificate", desc: "Request marriage license records from the Petersburg Circuit Court Clerk. Certified copies available for name changes and legal purposes.", url: "https://www.petersburgva.gov/" },
    { icon: "ri-file-copy-line", label: "Divorce Decree", desc: "Obtain certified divorce records through the Petersburg Circuit Court Clerk. Required for name change passport corrections.", url: "https://www.petersburgva.gov/" },
  ],
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Petersburg international flights and last-minute travel.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Tamika J.",
      location: "Petersburg, VA",
      rating: 5,
      text: "I live near the historic district of Petersburg and needed an emergency passport for a family trip to Jamaica with 5 days notice. Fast Passport Center had my renewal in 3 days. I shipped from the UPS on Washington Street and it was completely seamless. No need to drive to DC or wait in government lines.",
      service: "Emergency Passport",
    },
    {
      name: "Marcus W.",
      location: "Fort Lee, VA",
      rating: 5,
      text: "As a Fort Lee service member, I needed an expedited passport for an overseas assignment. Fast Passport Center made it incredibly easy. Everything was done online, and my passport was back in 4 days. The convenience for military families in the Tri-Cities is unbeatable.",
      service: "Passport Renewal",
    },
    {
      name: "Angela R.",
      location: "Colonial Heights, VA",
      rating: 5,
      text: "First passports for my two kids before a family trip to Mexico. Fast Passport Center handled all the parental consent requirements perfectly and had both passports in 6 days. For Colonial Heights families, this is the best expedited passport service available.",
      service: "Child Passport",
    },
    {
      name: "Derek S.",
      location: "Hopewell, VA",
      rating: 5,
      text: "Lost my passport 3 days before a business trip to Germany. I was in absolute panic. Fast Passport Center had a replacement in my hands in 48 hours. They saved my business trip. Tri-Cities professionals need this service.",
      service: "Lost Passport",
    },
  ],
  facilities: [
    {
      id: "petersburg-va-1",
      name: "Petersburg Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "Street address pending USPS listing",
      city: "Petersburg",
      state: "VA",
      zip: "23803",
      phone: "(804) 733-4261",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Petersburg",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Petersburg facility. Full passport services with appointment. Call ahead to confirm.",
      icon: "ri-mail-line",
    },
    {
      id: "petersburg-va-2",
      name: "Colonial Heights Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "Street address pending USPS listing",
      city: "Colonial Heights",
      state: "VA",
      zip: "23834",
      phone: "(804) 526-7221",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Colonial Heights, north of Petersburg",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Colonial Heights and Chesterfield. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "petersburg-va-3",
      name: "Hopewell Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "Street address pending USPS listing",
      city: "Hopewell",
      state: "VA",
      zip: "23860",
      phone: "(804) 541-8011",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Hopewell, northeast of Petersburg",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Hopewell and Prince George County. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "petersburg-va-4",
      name: "Fort Lee Post Office",
      type: "Military Post Office",
      address: "Street address pending USPS listing",
      city: "Fort Lee",
      state: "VA",
      zip: "23801",
      phone: "(804) 734-0001",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Fort Lee, east of Petersburg",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves military personnel and families at Fort Lee. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "petersburg-va-5",
      name: "Petersburg City Clerk",
      type: "City Clerk",
      address: "400 Adams St",
      city: "Petersburg",
      state: "VA",
      zip: "23803",
      phone: "(804) 733-2301",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "Petersburg City",
      website: "https://www.petersburgva.gov",
      websiteLabel: "Petersburg City Clerk",
      notes: "Provides vital records and birth certificates. Not a passport acceptance facility but useful for document collection.",
      icon: "ri-building-2-line",
    },
    {
      id: "petersburg-va-6",
      name: "Prince George County Clerk",
      type: "County Clerk",
      address: "PO Box 68",
      city: "Prince George",
      state: "VA",
      zip: "23875",
      phone: "(804) 722-8605",
      hours: "Mon–Fri: 8:30 AM – 4:30 PM",
      distance: "Prince George County",
      website: "https://www.princegeorgeva.org",
      websiteLabel: "Prince George Clerk",
      notes: "Provides vital records and birth certificates. Not a passport acceptance facility but useful for document collection.",
      icon: "ri-building-2-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 2+ hour drive to DC", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
    { feature: "Military & Government", agency: "No special handling", fpc: "Yes — priority for military and government travelers" },
    { feature: "Multi-Application Households", agency: "One slot per application", fpc: "Yes — family batch processing supported" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Petersburg photo shops often use generic sizes. Passport photos must be exactly 2x2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Tri-Cities acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Petersburg applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Washington DC regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Petersburg families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Petersburg travelers often assume standard processing will be fine. It takes 8-11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Petersburg or nearby." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Petersburg address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Petersburg before my international trip?", a: "Yes. Fast Passport Center provides emergency passport services in Petersburg for travelers with urgent international departures. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24-48 hour turnaround — perfect for last-minute trips from the Tri-Cities and Southside Virginia." },
    { q: "How fast can I renew my passport in Petersburg?", a: "Fast Passport Center offers fast passport renewal in Petersburg in as little as 24-48 hours through our emergency courier service. For less urgent travel, our 3-5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Petersburg?", a: "The nearest regional passport agency to Petersburg is the Washington Passport Agency, located approximately 130 miles north in downtown Washington, DC via I-95. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24-48 hour turnaround from Petersburg." },
    { q: "Can I get a same-day passport appointment near Petersburg?", a: "Same-day passport appointments are only available at the Washington Regional Passport Agency for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24-48 hour emergency courier processing is the fastest guaranteed option for Petersburg residents." },
    { q: "Can I expedite a child passport in Petersburg?", a: "Yes. Fast Passport Center expedites child passports in Petersburg for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Petersburg and Tri-Cities families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Petersburg with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24-48 hours." },
    { q: "How fast can I get a passport in Petersburg?", a: "With Fast Passport Center's emergency courier service, Petersburg travelers can receive their passport in as little as 24-48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities, bypassing standard mail delays." },
    { q: "Do I need to drive to the Washington Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
    { q: "Where are the closest passport acceptance facilities near Petersburg?", a: "Popular options include the Petersburg Main Post Office (23803), Colonial Heights Post Office (23834), Hopewell Post Office (23860), and Fort Lee Post Office (23801). All require appointments. We help you find the most convenient location and schedule your visit." },
    { q: "What if I live at Fort Lee, in Colonial Heights, or Hopewell?", a: "We serve the entire Tri-Cities region including Fort Lee, Colonial Heights, Hopewell, Chesterfield, and Chester. Our overnight shipping labels work from any UPS location, so your location doesn't affect processing speed. Military families at Fort Lee are especially well served with our fast processing." },
    { q: "How much does expedited passport service cost in Petersburg?", a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed — emergency 24-48 hour processing, 3-5 day expedited, or standard options. Contact us for a personalized quote." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Petersburg", address: "2015 S Crater Rd, Petersburg, VA 23805", hours: "Mon-Sun: 8AM-10PM" },
    { name: "Walgreens — Petersburg", address: "1000 W Washington St, Petersburg, VA 23803", hours: "Mon-Sun: 7AM-11PM" },
    { name: "CVS Pharmacy — Colonial Heights", address: "1800 Boulevard, Colonial Heights, VA 23834", hours: "Mon-Sun: 8AM-10PM" },
    { name: "Walgreens — Chester", address: "12300 Bermuda Crossroads Ln, Chester, VA 23831", hours: "Mon-Sun: 7AM-11PM" },
    { name: "CVS Pharmacy — Hopewell", address: "316 N 15th Ave, Hopewell, VA 23860", hours: "Mon-Sun: 8AM-10PM" },
    { name: "Walgreens — Richmond", address: "7001 W Broad St, Richmond, VA 23294", hours: "Mon-Sun: 7AM-11PM" },
  ],
  dmvLocations: [
    {
      name: "Virginia DMV — Petersburg",
      address: "1400 W Washington St, Petersburg, VA 23803",
      hours: "Mon-Fri: 8AM-5PM",
      note: "Driver's license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "Virginia DMV — Colonial Heights",
      address: "1900 Boulevard, Colonial Heights, VA 23834",
      hours: "Mon-Fri: 8AM-5PM",
      note: "REAL ID and passport-related ID services. Appointment strongly recommended.",
      featured: false,
    },
    {
      name: "Virginia DMV — Chesterfield",
      address: "6700 Woods Edge Rd, Richmond, VA 23225",
      hours: "Mon-Fri: 8AM-5PM",
      note: "Serves Chesterfield County. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "RIC",
      name: "Richmond International Airport",
      distance: "Located approximately 25 miles north of Petersburg",
      address: "1 Richard E. Byrd Terminal Dr, Richmond, VA 23250",
      note: "The closest international airport to Petersburg. International and domestic flights. Accessible via I-95.",
      flightUrl: "https://www.flyrichmond.com/",
      flightLabel: "RIC Airport",
      featured: true,
    },
    {
      code: "ORF",
      name: "Norfolk International Airport",
      distance: "Located approximately 85 miles southeast of Petersburg",
      address: "2200 Norview Ave, Norfolk, VA 23518",
      note: "Regional hub for Hampton Roads. Accessible via I-95 and I-64.",
      flightUrl: "https://www.norfolkairport.com/",
      flightLabel: "ORF Airport",
      featured: false,
    },
    {
      code: "PHF",
      name: "Newport News/Williamsburg International Airport",
      distance: "Located approximately 60 miles east of Petersburg",
      address: "1000 Bland Blvd, Newport News, VA 23602",
      note: "Regional hub for the Virginia Peninsula. Accessible via I-64.",
      flightUrl: "https://www.flyphf.com/",
      flightLabel: "PHF Airport",
      featured: false,
    },
  ],
};